export default (user = [], action) => {
    if(action.type==="PUT_USERID"){
        return action.payload;
    }
    return user;
};